const K = {
  // strapiV2Url: 'http://192.168.8.158:1337'
  // strapiV2Url: 'http://192.168.0.50:1337',
  strapiV2Url: 'https://strapi.service.hortusbox.com',
  userId: 'uid',
  projectClient: 'project-client',
  projectProductId: 'project-producId'
}

if (process.env.NODE_ENV === 'production') {
  K.strapiV2Url = 'https://strapi.service.hortusbox.com'
}

export default K